import { getEnvName } from './utils';

const envName = getEnvName(); // 环境变量
export function envPath(name = envName) {
  return name === 'pro' ? '' : `.${name}`;
}

// api接口相关
export const CASHBACK_BASE_URL = `https://api${envPath(envName)}.tinman.cn/mall/cashback`;
export const UC_API_DOMAIN = `https://uc-api${envPath(envName)}.tinman.cn`;
export const TRACE_BASE_URL = `https://api${envPath(envName)}.jojoread.com`;
export const TINMAN_BASE_URL = `https://api${envPath(envName)}.tinman.cn`;
export const TINMAN_BASE_C_URL = `https://api${envPath(envName)}.tinman.cn`;
//! CHECK mall-product 应该改为 mall/product
// export const MALL_BASE_URL = `https://mall-product${envPath(envName)}.tinman.cn`;
export const MALL_BASE_URL = `https://api${envPath(envName)}.tinman.cn/mall/product/api`;
// export const PAY_BASE_URL = `https://mall-pay${envPath(envName)}.tinman.cn`;
//! CHECK 支付应该改为 mall/pay
export const PAY_BASE_URL = `https://api${envPath(envName)}.tinman.cn/mall/pay`;
export const WEBSITE_URL = `boom${envPath(envName)}.tinman.cn`;
export const ORDER_BASE_URL = `https://mall-order${envPath(envName)}.tinman.cn`;

export const MALL_ORDER_LIST = `https://mall${envPath(envName)}.tinman.cn/order/list`;
// 订单详情页
export const MALL_ORDER_DETAIL = `https://mall${envPath(envName)}.tinman.cn/order/detail?orderId=`;

export const MALL_ADDRESS_LIST = `https://mall${envPath(envName)}.tinman.cn/address/list`;

export const EDU_POINTS = `https://edu${envPath(envName)}.tinman.cn/ap/points/detail`;
export const EDU_TOKEN = `https://edu${envPath(
  envName
)}.tinman.cn/ap/points/detail?assetType=8&fullScreen=true`;
// 抽奖的填地址
export const ACT_ADDRESS = `https://act${envPath(envName)}.tinman.cn/actAddress/address?rid=`;
// 打开APP地址
export const OPEN_APP = `https://act.tinman.cn/act2/qwerty/openApp.html?url=`;
// 邀请明细的填地址
export const Price_ADDRESS = `https://act${envPath(envName)}.tinman.cn/team/address`;
// 专辑详情页
export const READ_HUB = `https://jojoread${envPath(
  envName
)}.tinman.cn/web/tellStories/groupon-redirect-page`;

// 包名
export const PACKAGE_NAME = 'mp.tinman.JoJoRead';

// 授权失效之后进入链接地址
export const AUTH_SIGN_URL = 'https://uc-api.tinman.cn/page/wechatMp/portal/entrance';
export const AUTH_REDIRECT_PARAMS = 'au_prms';

// 非静默登陆登陆也
export const AUTH_INPUT_LOGIN = `https://jojoread${envPath(envName)}.tinman.cn/account/login`;

// 新的微信授权接口
export const AUTH_SIGN_URL_NEW = `https://uc-api${envPath(
  envName
)}.tinman.cn/api/user-center/wechatMp/login`;

export const PLACEHOLDER_MAP =
  'https://jojopublic.jojoread.com/mall/mall-cashback/activity/image/202104/e701cbe2324347ad8c2affc34cc0bf71.jpg';

export const SERVICE_URL = `https://act${envPath(
  envName
)}.tinman.cn/transform/customerCenter?fromType=ORDER`;

export const SENSORS_SERVER_URL = 'https://sensors.tinman.cn/sa?project=production';

export const READ_BASE_URL = 'https://jojoread.tinman.cn';
